import grants from './grants.svg';

export default function GrantsIcon() {
  return <img src={grants} alt={'grants'} width="32" height="32" />;
}
